// extracted by mini-css-extract-plugin
export default {"container":"vp-z","heading":"wp-z","text":"xp-z","info":"yp-z","link":"zp-z","fullMaxWidth":"Ap-z"};